import React from 'react';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';

const PartialStatus = ({ id, document_store }) => {
    const document = document_store.documents[id];
    const customersGroupIds = _.groupBy(document.deliveries, 'customer_id');
    let visitsCustomers = 0;

    for (const customerId in customersGroupIds) {
        const deliveries = customersGroupIds[customerId];
        const visits = { arrived: 0, pending: 0, delivered: 0, out_of_plan: 0, canceled: 0 };

        deliveries.forEach(delivery => {
            const key = delivery.status;
            visits[key] = visits[key] + 1;
        });

        const countInvoices = visits.canceled + visits.delivered + visits.out_of_plan;
        if (countInvoices > 0) {
            visitsCustomers++;
        }
    }

    const total = Object.keys(customersGroupIds).length;
    const percent = visitsCustomers > 0 ? (visitsCustomers * 100 / total) : 0;

    let classColor = 'c-green';

    if(percent <= 24) {
        classColor = 'c-red';
    } else if (percent > 24 && percent <= 50) {
        classColor = 'c-orange';
    } else if (percent > 50 && percent < 95) {
        classColor = 'c-orange';
    }

    return (
        <span title={'Visitas realizadas'} data-last-sync-at={document_store.updated_at} className={`${classColor}`}>{visitsCustomers} / {total} ({Math.round(percent) || '0'}%)</span>
    );
};

PartialStatus.defaultProps = {
    id: null
};

let container = observer(PartialStatus);
container = inject(['document_store'])(container);

export default container;



// WEBPACK FOOTER //
// ./src/components/Status/Visits.js